import success from '@/assets/img/orderInspection/success.png'
import fail from '@/assets/img/orderInspection/fail.png'
import any from '@/assets/img/orderInspection/any.png'
import sms from '@/assets/img/orderInspection/sms.png'
import im from '@/assets/img/orderInspection/im.png'
import call from '@/assets/img/orderInspection/call.png'
// 1 IM，2 虚拟电话，3 短信
const imgMap = {
  0: any,
  1: im,
  2: call,
  3: sms
}
const defaultBussBar = {
  orderData: {},
  title: '',
  loading: false,
  cb: () => {},
  proofUrls: [], // 上传的凭证图片
  remark: '', //补充说明
  medicalRecordData: {} //补充诊疗记录数据
}
export { imgMap, success, fail, defaultBussBar }
